import type { FamilyInviteView } from "@keydials/api-client";

/**
 * The invitation page's heading (KEY-651): who set them up with what. Kept out of the component so the wording
 * — and its fall-back when the rung names no dial — can be tested without a browser.
 */
export function joinHeading(invite: Pick<FamilyInviteView, "invitedBy" | "dials">): string {
  const dials = invite.dials;
  if (dials.length === 0) return `${invite.invitedBy} has set you up on Key Dials`;
  const names =
    dials.length === 1
      ? dials[0]
      : `${dials.slice(0, -1).join(", ")} and ${dials[dials.length - 1]}`;
  return `${invite.invitedBy} has set you up with your own ${names} ${dials.length === 1 ? "dial" : "dials"}`;
}
